module.exports = __webpack_public_path__ + "assets/img/vr_button.5274a3ad.png";